import script from "./CustomSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomSelect.vue?vue&type=script&setup=true&lang=ts"

import "./CustomSelect.vue?vue&type=style&index=0&id=22441a4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22441a4a"]])

export default __exports__